enum MultiFactorStrategy {
  TOTP = 'TOTP',
  SMS = 'SMS',
  Email = 'EMAIL'
}

export { MultiFactorStrategy }
